var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C7.97492 4.73748 1 8.77677 1 14.0625C1 16.7204 3.15462 18.875 5.8125 18.875C8.21142 18.875 10.006 17.5025 11.1601 16.2233C10.7498 19.6775 9.53543 21.3397 7.875 23H16.125C14.4645 21.3395 13.2501 19.6775 12.8399 16.2233C13.994 17.5026 15.7888 18.875 18.1875 18.875C20.8454 18.875 23 16.7204 23 14.0625C23 8.77677 16.0251 4.73748 12 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpades);
export default __webpack_public_path__ + "static/media/spades.fc0a3b45cfff4f8ddd2c10a1d16ad369.svg";
export { ForwardRef as ReactComponent };